import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { DotDelimeter } from '../../Zemplin/General/DotDelimeter';
import { getArticleDefaultInfo } from '../../../utilities/selectors';

export interface Props {
  article: any;
  categoryName: string | null;
}

function ArticleCard({ article, categoryName }: Props) {
  const { url, title, picture, date, author } = getArticleDefaultInfo(article);

  return (
    <Wrapper to={url}>
      <Image src={picture} alt={`Obrázok ku článku ${title}`} />
      <BottomWrapper>
        <Text>{title}</Text>
        <DateCategoryWrapper>
          <Date>{date}</Date>
          {categoryName && <DotDelimeter />}
          {categoryName && <CategoryName>{categoryName}</CategoryName>}
          {author && <DotDelimeter />}
          {author && <CategoryName>{author}</CategoryName>}
        </DateCategoryWrapper>
      </BottomWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-flow: column;
  margin-bottom: ${rem(32)};
  margin-right: ${rem(32)};
  width: 100%;
  max-width: ${rem(328)};
  border-radius: ${rem(4)};
  border: ${({ theme }) => theme.borders.primary};
  box-shadow: 0px 1px 4px #00000014;
  transition: box-shadow 0.3s;
  flex: 1 1 30%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.white};

  &:nth-child(3n) {
    margin-right: 0;
  }

  &:hover {
    box-shadow: ${({ theme }) => theme.boxShadow.default};
  }

  ${({ theme }) => theme.mediab.l925`
    flex: 1 1 48%;

    &:nth-child(3n) {
      margin-right: ${rem(32)};
    }

    &:nth-child(2n), &:nth-child(6n)  {
      margin-right: 0;
    }
  `}

  ${({ theme }) => theme.mediab.m760`
    flex: 1 1 35%;
  `}

  ${({ theme }) => theme.mediab.m580`
    flex: 1 1 100%;
    margin-right: 0;

    &:nth-child(3n) {
      margin-right: 0;
    }
  `}
`;

const Image = styled.img`
  width: 100%;
  max-height: ${rem(246)};
  border-radius: ${rem(2)};

  &:hover {
    transform: scale(1.05);
  }

  ${({ theme }) => theme.mediab.m580`
    max-height: ${rem(216)};
  `}
`;

const BottomWrapper = styled(FlexCol)`
  justify-content: center;
  width: 100%;
  padding: ${rem(24)};
  margin: 0 auto;

  ${({ theme }) => theme.mediab.l925`
  `}
`;

const Text = styled.h2`
  font-weight: 500;
  font-size: ${rem(20)};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(28)};
  margin: 0;
  margin-bottom: ${rem(24)};

  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  height: ${rem(56)};

  &:hover {
    text-decoration: underline;
  }

  ${({ theme }) => theme.mediab.l925`
    flex: 1 1 48%;
  `}
`;

const DateCategoryWrapper = styled(FlexRowCenterVertical)`
  border-top: ${({ theme }) => theme.borders.primary};
  padding-top: ${rem(24)};
  justify-content: center;
`;

const Date = styled(TextP)`
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(20)};
`;

const CategoryName = styled(Date)``;

export { ArticleCard };
